import List from '@mui/material/List';
import { useModal } from 'mui-modal-provider';
import * as React from 'react';
import { removeContacts } from '../../../../store/communicator';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import DialogConfirmAction from '../../../Shared/DialogConfirmAction/DialogConfirmAction';
import ApSchedulerListItem from './ApSchedulerListItem/ApSchedulerListItem';
import ApSchedulerListItemAssigned from './ApSchedulerListItemAssigned/ApSchedulerListItemAssigned';

export default function ApSchedulerContactsList() {
    const dispatch = useAppDispatch();
    const { showModal } = useModal();

    const buildStage = useAppSelector(state => {
        return state.communicator?.buildStage || 'EDIT';
    });

    const contacts = useAppSelector(state => {
        return state.communicator?.contacts || [];
    });

    const handleRemove = (event: React.MouseEvent<HTMLButtonElement>) => {
        const { contactId } = event.currentTarget.dataset;

        if (contactId) {
            const modal = showModal(DialogConfirmAction, {
                title: 'Remove Contact',
                description: 'Are you sure you want to remove this contact?',
                onConfirm: () => {
                    dispatch(removeContacts(contactId));
                },
                onCancel: () => {
                    modal.hide();
                },
            });
        }
    };

    return (
        <React.Fragment>
            <List>
                {contacts.map(cnt =>
                    buildStage === 'EDIT' ? (
                        <ApSchedulerListItem
                            key={cnt.contactId}
                            contact={cnt}
                            onRemoveHandler={handleRemove}
                        />
                    ) : (
                        <ApSchedulerListItemAssigned key={cnt.contactId} contact={cnt} />
                    ),
                )}
            </List>
        </React.Fragment>
    );
}
